import {SimplePresentation, SimplePresentationRunnerController} from "../../core/presentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {HOTB} from "../HOTB";
import {GameUtils} from "../utils/GameUtils";

export class BufferTimePresentation implements SimplePresentation {
    private _mainTl: gsap.core.Timeline;

    public shouldRun(): boolean {
        return HOTB.model.data.betWayWins.length === 0;
    }

    public start(controller: SimplePresentationRunnerController): void {
        this._mainTl = gsap.timeline({
            delay: 0.2,
            onComplete: (): void => {
                this._mainTl.kill();
                controller.finish();
            }
        });

        this._mainTl.add((): void => {
            controller.setSkipCallback((): void => {
                this.onSkip();
            });
        }, 0.001);

        this._mainTl.to(this, {
            duration: GameUtils.isFastSpin() ? 0.001 : 0.3
        });
    }


    private onSkip(): void {
        // this._mainTl.timeScale(5);
        this._mainTl.progress(1);
    }
}